export const OFFER_GENERATED_DESCRIPTION_FLAT_CONTENT = {
    AVAILABLE_FLATS_HEADER: "Dostępne są mieszkania:",
    getMdmParagraph: (params: {areVerb: string; flatsLabel: string; mdmCount: number; metVerb: string; offerName: string}) =>
        `Aktualnie w inwestycji ${params.offerName} w sprzedaży ${params.areVerb} się ${params.mdmCount} ${params.flatsLabel}, które ${params.metVerb} kryteria MDM 2018.`
} as const;
export const OFFER_GENERATED_DESCRIPTION_FLAT_CONTENT = {
    AVAILABLE_FLATS_HEADER: "Dostępne są mieszkania:",
    getMdmParagraph: (params: {areVerb: string; flatsLabel: string; mdmCount: number; metVerb: string; offerName: string}) =>
        `Aktualnie w inwestycji ${params.offerName} w sprzedaży ${params.areVerb} się ${params.mdmCount} ${params.flatsLabel}, które ${params.metVerb} kryteria MDM 2018.`
} as const;
